import { render, staticRenderFns } from "./PlanBlock.vue?vue&type=template&id=7ce8656a&scoped=true&"
import script from "./PlanBlock.vue?vue&type=script&lang=js&"
export * from "./PlanBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce8656a",
  null
  
)

export default component.exports